//asset imports
import presskit1Img from "../../Assets/Images/presskit-1.jpg";
import presskit2Img from "../../Assets/Images/presskit-2.jpg";
import presskit3Img from "../../Assets/Images/presskit-3.jpg";

//style imports
import "../../Styling/section.scss";
import "./pressKit.scss";

export default function PressKit() {
    return (
        <section className='presskit__page'>
            <h2 className="presskit__title">Press Kit</h2>
            
            <div className="presskit__bio">
                <h3 className="presskit__bio-title">Bio</h3>
                <p className="presskit__bio-text">
                    Shen Tao immigrated to Canada at an early age, and grew up inspired by both Chinese and Western stories. 
                    She has wanted to be a writer for as long as she can remember. <em>The Poet Empress</em> is her first book.
                </p>
            </div>

            <div className="presskit__images">
                <h3 className="presskit__images-title">Images</h3>
                <div className="presskit__image-grid">
                    <div className="presskit__image-container">
                        <img 
                            className="presskit__image" 
                            src={presskit1Img} 
                            loading="lazy" 
                            alt="Shen Tao - Credit: Yuqi Shan"
                        />
                        <p className="presskit__image-caption">Photo credit: Yuqi Shan</p>
                    </div>
                    <div className="presskit__image-container">
                        <img 
                            className="presskit__image" 
                            src={presskit2Img} 
                            loading="lazy" 
                            alt="Shen Tao - Credit: Yuqi Shan"
                        />
                        <p className="presskit__image-caption">Photo credit: Yuqi Shan</p>
                    </div>
                    <div className="presskit__image-container">
                        <img 
                            className="presskit__image" 
                            src={presskit3Img} 
                            loading="lazy" 
                            alt="Shen Tao holding a copy of The Poet Empress - Credit: Yuqi Shan"
                        />
                        <p className="presskit__image-caption">Photo credit: Yuqi Shan</p>
                    </div>
                </div>
            </div>

            <div className="presskit__credit">
                <p className="presskit__credit-text">
                    Please credit all photos to "Yuqi Shan," or tagged @_yuqishan_ if appearing on Instagram
                </p>
            </div>
        </section>
    )
}